var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8368 3.11655L10.5535 0.833215C10.2555 0.553295 9.86499 0.392681 9.45628 0.381925C9.04756 0.371169 8.64915 0.511023 8.33684 0.774882L0.836836 8.27488C0.567474 8.54652 0.399756 8.90255 0.361836 9.28322L0.00350246 12.7582C-0.00772341 12.8803 0.0081144 13.0033 0.0498868 13.1185C0.0916592 13.2338 0.158338 13.3384 0.245169 13.4249C0.323036 13.5021 0.415383 13.5632 0.516914 13.6047C0.618445 13.6462 0.727164 13.6672 0.836836 13.6665H0.911836L4.38684 13.3499C4.7675 13.312 5.12353 13.1442 5.39517 12.8749L12.8952 5.37488C13.1863 5.06735 13.3436 4.65697 13.3327 4.23366C13.3217 3.81035 13.1434 3.40864 12.8368 3.11655ZM4.23684 11.6832L1.73684 11.9165L1.96184 9.41655L6.67017 4.76655L8.92017 7.01655L4.23684 11.6832ZM10.0035 5.89988L7.77017 3.66655L9.39517 1.99988L11.6702 4.27488L10.0035 5.89988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditwhite);
export default __webpack_public_path__ + "static/media/editwhite.841d20875455fac3da828da862dd2dd8.svg";
export { ForwardRef as ReactComponent };